import { Box, Stack, Typography } from '@mui/material';
import { style } from './style';

type AccountTrialStatusProps = {
  icon: JSX.Element,
  text: string,
  paid? : boolean,
  planDisplayName?: string,
}
export const AccountTrialStatus = ({
  icon,
  text,
  paid,
  planDisplayName,
}: AccountTrialStatusProps):JSX.Element => {
  return (
    <Typography variant="subtitle1" sx={ style.Typography.sx }>
      <Stack direction="column">
        <Stack direction="row">
          <Box sx={ style.span }>{icon}</Box>
          <span style={ style.span }>{text}</span>
        </Stack>

        <span style={ style.description }>
          {paid && planDisplayName && (
            `${planDisplayName}`
          )}
        </span>
      </Stack>

    </Typography>
  );
};

AccountTrialStatus.defaultProps = {
  paid: false,
  planDisplayName: '',
};
